













import { Component, Vue, Prop } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import InfiniteLoading from 'vue-infinite-loading';
import Spinner from '@/components/Media/Spinner.vue';
import { debounce } from 'lodash';

@Component({
    components: {
        InfiniteLoading,
        Spinner,
    },
})
export default class InfiniteScroll extends Vue {
    @Prop({ default: '' }) public action: string;
    @Prop({ default: null }) public additionalFilters: any;

    public page: number = 1;
    public infiniteHandler: any | null;

    constructor() {
        super();

        this.infiniteHandler = debounce(($state: any) => {
            if (this.action === '') {
                return false;
            }

            const data = this.additionalFilters
                ? {page: this.page, loaderState: $state, filters: this.additionalFilters}
                : {page: this.page, loaderState: $state};

            // @ts-ignore
            this.$store.dispatch(Actions[this.action], data)
                .then(() => {
                    this.page += 1;
                });
        }, 300);
    }
}
